var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"to":{ path: ("/" + (_vm.site.id) + "-" + (_vm.site.name)) }}},[_vm._v(" "+_vm._s(_vm.site.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }